// extracted by mini-css-extract-plugin
export default {"cardWrapper":"auth_cardWrapper__-F7Gk"};